export const IMG_TOP_MAX = 330;
export const IMG_TOP_MIN = 120;
export const IMG_W_MAX = 450; // 464.2 h
export const IMG_W_MIN = 200; // 206.3 h